import type { VoyagePnlData } from "../../models/UtilFunctions.model";
import { atom } from "jotai";

export const PnlContext = atom<VoyagePnlData | null>(null);
